import { render } from "./ExtremeNetworks.vue?vue&type=template&id=4dfa3a81"
import script from "./ExtremeNetworks.vue?vue&type=script&lang=ts"
export * from "./ExtremeNetworks.vue?vue&type=script&lang=ts"
script.render = render

export default script